import React from 'react';

import { Link, Typography } from '@mui/material';

import { BorrowersTestIds } from '../../../../../../Borrowers.testIds';

const AgencyIdNumberTitle = () => (
  <Typography className="additional-title mb-10" variant="regular14">
    Who provided it: If a HUD-approved agency, provide the Housing Counseling Agency ID Number (For
    a list of HUD-approved agencies go to:{' '}
    <Link
      data-testid={BorrowersTestIds.HOMEOWNERSHIP_EDUCATION_FORM_HUD_AGENCIES_LINK}
      href="https://www.hud.gov/program_offices/housing/sfh/hcc"
      rel="noreferrer"
      target="_blank"
    >
      https://www.hud.gov/program_offices/housing/sfh/hcc
    </Link>
    )
  </Typography>
);

export default AgencyIdNumberTitle;
